import React from "react";
import { Box, Typography, Container } from "@mui/material";
import Head from "next/head";

const AccessDeniedContent = () => {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Head>
        <title>Access Denied | The Food Exchange</title>
      </Head>
      <Container maxWidth="sm">
        <Box
          sx={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 3,
          }}
        >
          <Box
            component="img"
            src="/images/403.svg"
            alt="403 Access Denied"
            sx={{
              width: "100%",
              maxWidth: 300,
              height: "auto",
            }}
          />
          <Typography variant="h4" color="text.secondary" fontWeight={600}>
            Access Denied
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 400 }}>
            You don't have permission to view this page. Please contact your administrator if you believe this is an error.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default AccessDeniedContent;
